import styled from 'styled-components'

export const SellerMetricsContainer = styled.div(
  ({ theme }) => `
  display: grid;
  gap: ${theme.spacing.default};
  grid-template-columns: 1fr auto 1fr auto 1fr;
`
)
